import { render } from "./ContTitle.vue?vue&type=template&id=60c85672&scoped=true"
import script from "./ContTitle.vue?vue&type=script&lang=js"
export * from "./ContTitle.vue?vue&type=script&lang=js"

import "./ContTitle.vue?vue&type=style&index=0&id=60c85672&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c85672"]])

export default __exports__